import styled, { css } from 'styled-components';
import { slugify } from '@codex-brightworld/helpers';

/**
 * @tags styled, heading, headline, title
 */
const createHeading = level => styled[`h${level}`]
  .attrs(props => ({ 'data-qa': props.qa, 'id': props.id || slugify(props.children) }))`
  ${({ theme }) => css`
  font-family: ${theme.fonts.default.fontFamily};
  font-weight: ${theme.fontWeights.normal};
  color: ${theme.colors.neutral.currysBlack};

  ${level === 1 && `
      margin: 0 0 7px;
      font-size: 20px;
      line-height: 29px;

      @media ${theme.breakpoints.tablet} {
        margin-bottom: 6px;
      }

      @media ${theme.breakpoints.mobile} {
        margin-bottom: 17px;
      }
    `}

    ${level === 2 && `
      margin: 0 0 11px;
      font-size: 20px;
      line-height: 24px;
    `}

    ${level === 3 && `
      margin: 0 0 ${theme.spacing[2]};
      font-size: 18px;
      line-height: 22px;
    `}

    ${level === 4 && `
      margin: 0 0 ${theme.spacing[2]};
      font-size: 16px;
      line-height: 20px;
    `}
  `}
`;

const createParagraph = level => styled.p
  .attrs(props => ({ 'data-qa': props.qa, 'id': props.id || slugify(props.children) }))`
  ${({ theme }) => css`
    ${level === 1 && `
      margin: 0 0 ${theme.spacing[2]};
      font-weight: ${theme.fontWeights.normal};
      font-size: 14px;
      line-height: 21px;
      font-family: ${theme.fonts.default.fontFamily};
    `}

    ${level === 2 && `
      margin: 0 0 ${theme.spacing[2]};
      font-weight: ${theme.fontWeights.normal};
      font-size: 12px;
      line-height: 18px;
      font-family: ${theme.fonts.default.fontFamily};
    `}

    ${level === 3 && `
      margin: 0 0 ${theme.spacing[2]};
      font-weight: ${theme.fontWeights.normal};
      font-size: 14px;
      line-height: 21px;
      font-family: ${theme.fonts.default.fontFamily};
      color: ${theme.colors.primary.purple};
    `}
  `}
`;

export const H1 = createHeading(1);
export const H2 = createHeading(2);
export const H3 = createHeading(3);
export const H4 = createHeading(4);

export const P1 = createParagraph(1);
export const P2 = createParagraph(2);
export const P3 = createParagraph(3);
